const RoutePaths = {
	StartPage: '/start',
};

export default RoutePaths;
